import { ReactNode } from 'react'
import { Navigation } from './Navigation'
import { SkipToContent } from './SkipToContent'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-[#F7FAFC]">
      {/* Skip to main content link for keyboard users */}
      <SkipToContent />
      {/* Navigation */}
      <Navigation />

      {/* Main content */}
      <main id="main-content" className="pt-16">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-[#E2E8F0] mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <p className="text-center text-sm text-[#718096]">
            © {new Date().getFullYear()} Steadfast HSA. Built for the long term.
          </p>
        </div>
      </footer>
    </div>
  )
}
